
import { mapActions, mapGetters } from 'vuex'
import { checkLatinString } from '../utils/StringUtils'

export default {
  name: 'Register',
  data () {
    return {
      errorMessages: [],
      isError: false,
      acceptTerms: false,
      captcha: null,
      sectors: [],
      countries: [],
      tabLeads: [],
      tabLookingFor: [],
      tabSubjectsInterest: [],
      tabGeographicSpan: [],
      form: {
        id: 'yearbook_register',
        title: null,
        lastName: null,
        firstName: null,
        mail: null,
        function: null,
        department: null,
        phone: null,
        language: this.$i18n.locale,
        companyName: null,
        sector: null,
        country: null,
        leadTrackingInformation: null,
        leadTrackingDetail: null,
        dailyEnergyNewsletter: true,
        asiaWeeklyEnergyNewsletter: false,
        offersEnerdata: true,
        newsletterEnerdata: true,
        lookingFor: [],
        detailLookingFor: null,
        subjectsInterest: [],
        geographicSpan: [],
        particularPoint: null,
        password: null,
        confirmPassword: null,
        captchaSolution: null,
        captchaId: null,
        captchaToken: null
      },
      has_minimum_length: false,
      has_number: false,
      has_letter: false,
      has_special: false,
      is_identical: false,
      lastNameHasOnlyLatinCharacters: null,
      firstNameHasOnlyLatinCharacters: null
    }
  },
  async fetch () {
    this.sectors = await this.$customer.getListOptions('secteur', this.$i18n.locale)
    this.countries = await this.$customer.getListCountries(this.$i18n.locale)
    this.tabLeads = await this.$customer.getListOptions('leads-tracking', this.$i18n.locale)
    this.tabLookingFor = await this.$customer.getListOptions('looking-for', this.$i18n.locale)
    this.tabSubjectsInterest = await this.$customer.getListOptions('subjects-interest', this.$i18n.locale)
    this.tabGeographicSpan = await this.$customer.getListOptions('geographic-span', this.$i18n.locale)
    this.captcha = await this.$customer.getCaptcha(this.form.id)
  },
  fetchOnServer: false,
  head () {
    const i18nHead = this.$nuxtI18nHead({ addSeoAttributes: true })
    return {
      title: this.$i18n.t('seo.register.title'),
      htmlAttrs: {
        ...i18nHead.htmlAttrs
      },
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.$i18n.t('seo.register.description')
        },
        {
          hid: 'keywords',
          name: 'keywords',
          content: this.$i18n.t('seo.register.keyWords')
        },
        {
          property: 'og:type',
          content: 'website'
        },
        {
          property: 'og:title',
          content: this.$i18n.t('seo.register.title')
        },
        {
          property: 'og:url',
          content: 'https://' + this.$i18n.localeProperties.domain + this.$route.fullPath
        },
        {
          property: 'og:description',
          content: this.$i18n.t('seo.register.description')
        },
        {
          property: 'twitter:card',
          content: 'summary'
        },
        {
          property: 'twitter:site',
          content: '@Enerdata'
        },
        {
          property: 'twitter:title',
          content: this.$i18n.t('seo.register.title')
        },
        {
          property: 'twitter:description',
          content: this.$i18n.t('seo.register.description')
        },
        ...i18nHead.meta
      ],
      link: [
        ...i18nHead.link
      ]
    }
  },
  computed: {
    ...mapGetters({
      requestedDownload: 'requestedDownload'
    }),
    pageLandscapeImage () {
      return require('../assets/images/jumbotron/homepage.jpg')
    },
    sectorOptions () {
      const returnedList = []
      returnedList.push({ value: null, text: this.$i18n.t('registerPage.placeholder.sector') })
      const n = this.sectors.length
      for (let i = 0; i < n; i++) {
        const item = this.sectors[i]
        returnedList.push({ value: item.valueId, text: item.intitule })
      }
      return returnedList
    },
    countryOptions () {
      const returnedList = []
      returnedList.push({ value: null, text: this.$i18n.t('registerPage.placeholder.country') })
      const n = this.countries.length
      for (let i = 0; i < n; i++) {
        const item = this.countries[i]
        returnedList.push({ value: item.codeIso, text: item.intitule })
      }
      return returnedList
    },
    leadTrackingInformationOptions () {
      const returnedList = []
      returnedList.push({ value: null, text: this.$i18n.t('registerPage.placeholder.leadTrackingInformation') })
      const n = this.tabLeads.length
      for (let i = 0; i < n; i++) {
        const item = this.tabLeads[i]
        returnedList.push({ value: item.valueId, text: item.intitule })
      }
      return returnedList
    },
    lookingForOptions () {
      const returnedList = []
      const n = this.tabLookingFor.length
      for (let i = 0; i < n; i++) {
        const item = this.tabLookingFor[i]
        returnedList.push({ value: item.valueId, text: item.intitule })
      }
      return returnedList
    },
    subjectsOptions () {
      const returnedList = []
      const n = this.tabSubjectsInterest.length
      for (let i = 0; i < n; i++) {
        const item = this.tabSubjectsInterest[i]
        returnedList.push({ value: item.valueId, text: item.intitule })
      }
      return returnedList
    },
    geographicSpanOptions () {
      const returnedList = []
      const n = this.tabGeographicSpan.length
      for (let i = 0; i < n; i++) {
        const item = this.tabGeographicSpan[i]
        returnedList.push({ value: item.valueId, text: item.intitule })
      }
      return returnedList
    },
    captchaQuestion () {
      if (this.captcha !== null) {
        return this.captcha.question.texte + ' ' + this.captcha.words.join(', ')
      } else {
        return null
      }
    },
    isLookingForOther () {
      return this.form.lookingFor !== null && this.form.lookingFor.includes('OTHER')
    }
  },
  watch: {
    form: {
      handler () {
        if (this.form.password !== null) {
          this.has_minimum_length = (this.form.password.length >= 12)
          this.has_number = /\d/.test(this.form.password)
          this.has_letter = /[a-z]/i.test(this.form.password)
          this.has_special = /[`~!@#$%^&*()_+=\-|}{"?:><,./;'\\[\]]/.test(this.form.password)
          this.is_identical = this.form.password === this.form.confirmPassword
        }
      },
      deep: true
    },
    captcha: {
      handler () {
        if (this.captcha !== null) {
          this.form.captchaSolution = null
          this.form.captchaId = this.captcha.captchaSession.id
          this.form.captchaToken = this.captcha.captchaSession.token
        }
      },
      deep: true
    }
  },
  methods: {
    ...mapActions({
      setMessage: 'home/setMessage'
    }),
    async userRegister () {
      this.isError = false
      const passwordSecurityMessages = this.checkPasswordSecurity()
      const latinStringMessages = this.checkLatinString()
      if (passwordSecurityMessages.length > 0) {
        this.errorMessages = passwordSecurityMessages
        this.isError = true
      } else if (latinStringMessages.length > 0) {
        this.errorMessages = latinStringMessages
        this.isError = true
      } else {
        this.errorMessages = []
        try {
          if (!this.isLookingForOther) {
            this.form.detailLookingFor = null
          }
          await this.$customer.sendRegister(this.form)
          const valSector = this.leadTrackingInformationOptions.find(item => item.value === this.form.leadTrackingInformation)?.text
          const valReferral = this.form.leadTrackingDetail ?? ''
          let target = 'register_form'
          if (this.requestedDownload !== null) {
            target = this.requestedDownload
          }
          this.$gtm.push({
            event: 'sign_up',
            sector: valSector,
            referral: valReferral,
            destination: target,
            origine: this.form.id,
            user_data: {
              user_id: '',
              firstName: this.form.firstName,
              lastName: this.form.lastName,
              email: this.form.mail
            }
          })
          if (this.form.dailyEnergyNewsletter ||
            this.form.asiaWeeklyEnergyNewsletter ||
            this.form.offersEnerdata ||
            this.form.newsletterEnerdata) {
            this.$gtm.push({
              event: 'subscribe_newsletter',
              sector: valSector,
              referral: valReferral,
              newsletter_name: {
                kei: this.form.dailyEnergyNewsletter,
                kei_asia: this.form.asiaWeeklyEnergyNewsletter,
                nl_offers: this.form.offersEnerdata,
                nl_360: this.form.newsletterEnerdata
              }
            })
          }
          const message = {
            type: 'success',
            content: [
              this.$i18n.t('registerPage.message.success.thankSignup'),
              this.$i18n.t('registerPage.message.success.toActivate')
            ]
          }
          this.setMessage(message)
          await this.$router.push('/')
        } catch (err) {
          this.refreshCaptcha()
          this.errorMessages.push(err.response.data.message)
          this.isError = true
        }
      }
      window.scrollTo(0, 0)
    },
    checkPasswordSecurity () {
      const passwordSecurityMessages = []
      if (!this.has_minimum_length) {
        passwordSecurityMessages.push(this.$i18n.t('forgotPasswordPage.passwordSecurity.length'))
      }
      if (!this.has_number || !this.has_letter) {
        passwordSecurityMessages.push(this.$i18n.t('forgotPasswordPage.passwordSecurity.alphaNum'))
      }
      if (!this.has_special) {
        passwordSecurityMessages.push(this.$i18n.t('forgotPasswordPage.passwordSecurity.special'))
      }
      if (!this.is_identical) {
        passwordSecurityMessages.push(this.$i18n.t('forgotPasswordPage.passwordSecurity.identical'))
      }
      if (passwordSecurityMessages.length > 0) {
        passwordSecurityMessages.unshift(this.$i18n.t('forgotPasswordPage.passwordSecurity.title'))
      }
      return passwordSecurityMessages
    },
    checkLatinString () {
      const latinStringMessages = []
      this.lastNameHasOnlyLatinCharacters = null
      this.firstNameHasOnlyLatinCharacters = null
      if (this.form.firstName !== null && !checkLatinString(this.form.firstName)) {
        this.firstNameHasOnlyLatinCharacters = false
        latinStringMessages.push(this.$i18n.t('registerPage.label.firstname') + ': ' + this.$i18n.t('registerPage.message.error.notOnlyLatinCharacters'))
      }
      if (this.form.lastName !== null && !checkLatinString(this.form.lastName)) {
        this.lastNameHasOnlyLatinCharacters = false
        latinStringMessages.push(this.$i18n.t('registerPage.label.name') + ': ' + this.$i18n.t('registerPage.message.error.notOnlyLatinCharacters'))
      }
      return latinStringMessages
    },
    refreshCaptcha () {
      this.$fetch()
    }
  }
}
